import { render } from "./MediaItem.vue?vue&type=template&id=80fe7ed0"
import script from "./MediaItem.vue?vue&type=script&lang=js"
export * from "./MediaItem.vue?vue&type=script&lang=js"

import "./MediaItem.vue?vue&type=style&index=0&id=80fe7ed0&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__